import React from 'react';
import {View, Platform, Dimensions} from 'react-native';

import Screen from '../../shared/components/screen';

import {ServicesContent} from '../../shared/components/content';
import {useDeviceSize, DeviceSize} from '../../shared/theme/helpers';
import {Text} from '../../shared/components/text';
import {CustomScrollView} from '../../shared/components/scrollView';
import {useStyles} from '../../shared/hooks/styles';
import {useTheme} from '../../shared/theme';
import {GradientView} from '../../shared/components/gradientView';
import {Container} from '../../shared/components/container';

export default () => {
  const theme_ = useTheme();
  const styles = useStyles(({theme, isDesktop}) => ({
    contentContainer: {
      flex: 1,
    },
    sectionContainer: {
      flex: Platform.OS === 'ios' ? undefined : 1,
      height: Platform.OS === 'ios' ? Dimensions.get('screen').height : undefined,
      paddingTop: Platform.select({android: 30, ios: 30, web: 30}),
      paddingBottom: theme.screen.bottomOffset - (isDesktop ? 40 : -10),
    },
    gradientContainer: {
      flex: 1,
      position: 'relative',
    },
    gradientHead: {
      position: 'absolute',
      top: 0,
      left: 0,
      right: 0,
      height: '40%',
    },
    gradientBottom: {
      position: 'absolute',
      bottom: 0,
      left: 0,
      right: 0,
      height: '40%',
    },
    sectionTitle: {marginBottom: 69},
  }));
  const size = useDeviceSize();

  return (
    <Screen fullWidth>
      <CustomScrollView contentInsetAdjustmentBehavior='automatic' contentContainerStyle={styles.contentContainer}>
        <GradientView style={styles.gradientContainer} gradient={{angle: 90, colors: theme_.services.bgGradient}}>
          <GradientView
            style={styles.gradientHead}
            gradient={{
              angle: 180,
              colors: theme_.services.bgGradientHead,
            }}
          />
          <GradientView
            style={styles.gradientBottom}
            gradient={{
              colors: theme_.services.bgGradientHead,
            }}
          />
          <Container>
            <View style={styles.sectionContainer}>
              {size === DeviceSize.desktop ? (
                <Text style={styles.sectionTitle} testID='screen-header--title' type='h1'>
                  Доступные возможности
                </Text>
              ) : null}
              <ServicesContent useBackgroundPattern />
            </View>
          </Container>
        </GradientView>
      </CustomScrollView>
    </Screen>
  );
};
